import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class GradesService {

    constructor(private http: HttpClient) { }

    getAllGrades() {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/grades`)
    }
    getStudentsByClassId(classId, enrollDate) {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/students/level_up?class_id=${classId}
         ${enrollDate ? `&enrollment_date=${enrollDate}` : ''}`)
    }
    deleteStudents(body) {
        body["_method"] = "DELETE";
        body["type"] = "graduated";
        return this.http.post(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/students/delete`, body)
    }
    transferStudents(body) {
        return this.http.put(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/students/level_up`, body)
    }

    getGradeClasses(gradeId, getGenderCounts) {
        return this.http.get(environment.url + `v2/schools/${localStorage.getItem('schoolId')}/grades/${gradeId}/classes?with_students_count=${getGenderCounts}`);
    }

    checkGradeNameUniqueness(body) {
        return this.http.post(environment.url + `v2/schools/${localStorage.getItem('schoolId')}/grades/check-grade-by-name`, body)
    }

    splitGradeByGender(gradeId, body) {
        return this.http.post(environment.url + `v2/schools/${localStorage.getItem('schoolId')}/grades/${gradeId}/split-grade-by-gender`, body)
    }

    studentsTransfer(classId, body) {
        return this.http.post(environment.url + `v2/schools/${localStorage.getItem('schoolId')}/classes/${classId}/transfer`, body)
    }

    studentsTransferByGender(classId, body) {
        return this.http.post(environment.url + `v2/schools/${localStorage.getItem('schoolId')}/classes/${classId}/transfer-by-gender`, body)
    }


    getExcludedStudents(gradeId: string, classIds: any[], enrollmentDates: any[], gender: string) {
        let params = new URLSearchParams();

        // Always add class_ids[] even if empty
        if (classIds.length > 0) {
            classIds.forEach((id: string) => {
                params.append('class_ids[]', id);
            });
        }

        // Always add enrollment_dates[] even if empty
        if (enrollmentDates.length > 0) {
            enrollmentDates.forEach((date: string) => {
                params.append('enrollment_dates[]', date);
            });
        }

        if (gender !== undefined && gender !== null) {
            params.append('gender', gender);
        }

        const url = `${environment.url}v2/schools/${localStorage.getItem('schoolId')}/grades/${gradeId}/excluded-students?${params.toString()}`;
        return this.http.get(url);
    }

    gradeTransfer(gradeId, body) {
        return this.http.post(environment.url + `v2/schools/${localStorage.getItem('schoolId')}/grades/${gradeId}/transfer`, body)
    }

    gradeTransferByGender(gradeId, body) {
        return this.http.post(environment.url + `v2/schools/${localStorage.getItem('schoolId')}/grades/${gradeId}/transfer-by-gender`, body)
    }

}